<template>
  <Catalog
    title="Статус исполнителя в заявке"
    name-label="Название"
    submit-error="Укажите название."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
import Catalog from "../Catalog.vue";

export default {
  name: "TaskWorkerStatus",
  components: { Catalog },
  mixins: [ catalogs ],
  methods: {
    async fetchData(id) {
      return await this.getTaskWorkerStatusById(id);
    },
    async putData(data) {
      return await this.putTaskWorkerStatus(data);
    },
    async postData(data) {
      return await this.postTaskWorkerStatus(data);
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/TaskWorkerStatuses/TaskWorkerStatus.vue